import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SuccessConfirmation = ({ selectedRole, onReturnHome }) => {
  return (
    <div className="max-w-2xl mx-auto text-center space-y-6 md:space-y-8 py-8 md:py-12">
      <div className="w-16 h-16 md:w-20 md:h-20 rounded-xl bg-[#10B981]/10 border-2 border-[#10B981]/20 flex items-center justify-center mx-auto">
        <Icon name="CheckCircle2" size={40} color="#10B981" />
      </div>

      <div className="space-y-3">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-[#111827]">
          Application Submitted Successfully
        </h2>
        <p className="text-base md:text-lg text-[#6B7280] max-w-xl mx-auto">
          Thank you for your interest in BlinD. Your application is now under review.
        </p>
      </div>

      <div className="bg-[#F6F7FB] rounded-2xl p-6 md:p-8 space-y-4 text-left">
        <h3 className="text-lg md:text-xl font-semibold text-[#111827]">
          What happens next?
        </h3>

        <div className="space-y-4">
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 rounded-lg bg-[#0025cc]/10 flex items-center justify-center flex-shrink-0">
              <Icon name="FileSearch" size={18} color="#0025cc" />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm md:text-base font-medium text-[#111827] mb-1">
                Application Review
              </h4>
              <p className="text-xs md:text-sm text-[#6B7280]">
                Our team will review your application within 24-48 hours
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="w-8 h-8 rounded-lg bg-[#06B6D4]/10 flex items-center justify-center flex-shrink-0">
              <Icon name="Timer" size={18} color="#06B6D4" />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm md:text-base font-medium text-[#111827] mb-1">
                Approval Timeline
              </h4>
              <p className="text-xs md:text-sm text-[#6B7280]">
                Approved candidates receive access within 2-3 business days
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="w-8 h-8 rounded-lg bg-[#10B981]/10 flex items-center justify-center flex-shrink-0">
              <Icon name="Send" size={18} color="#10B981" />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm md:text-base font-medium text-[#111827] mb-1">
                Email Confirmation
              </h4>
              <p className="text-xs md:text-sm text-[#6B7280]">
                Check your inbox for a confirmation email with next steps
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white border border-[#E5E7EB] rounded-2xl p-6 md:p-8">
        <div className="flex items-start gap-3 mb-4">
          <Icon name="AlertCircle" size={20} color="#0025cc" className="flex-shrink-0 mt-0.5" />
          <div className="flex-1 min-w-0 text-left">
            <h4 className="text-sm md:text-base font-medium text-[#111827] mb-2">
              Important Information
            </h4>
            <ul className="space-y-2 text-xs md:text-sm text-[#6B7280]">
              <li className="flex items-start gap-2">
                <span className="text-[#0025cc] mt-1">•</span>
                <span>Check your spam folder if you don't receive our email</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#0025cc] mt-1">•</span>
                <span>
                  {selectedRole === 'candidate' ? 'Ensure you have 8+ years of verifiable experience' : 'Verify your company email domain is accessible'}
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#0025cc] mt-1">•</span>
                <span>Applications are reviewed in order of submission</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row gap-3 justify-center pt-4">
        <Button variant="outline" size="lg" onClick={onReturnHome}>
          Return to Home
        </Button>
        <Button
          variant="default"
          size="lg"
          iconName="ExternalLink"
          iconPosition="right"
          onClick={() => window.open('https://linkedin.com/company/blind', '_blank')}
        >
          Follow Us on LinkedIn
        </Button>
      </div>
    </div>
  );
};

export default SuccessConfirmation;